import WeatherLocationId from 'owa-service/lib/contract/WeatherLocationId';
import WeatherLocationType from 'owa-service/lib/contract/WeatherLocationType';
import LocationCommonWellItemViewState from 'owa-location-common-well/lib/store/schema/LocationCommonWellItemViewState';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';

export function getLocationTypeFromLocationId(locationId: WeatherLocationId): WeatherLocationType {
    return {
        LocationId: locationId.EntityId,
        Name: locationId.Name,
        Latitude: locationId.Latitude.toString(),
        Longitude: locationId.Longitude.toString(),
    };
}

export function getLocationIdFromLocationType(
    locationType: WeatherLocationType
): WeatherLocationId {
    return {
        EntityId: locationType.LocationId,
        Name: locationType.Name,
        Latitude: parseFloat(locationType.Latitude),
        Longitude: parseFloat(locationType.Longitude),
    };
}

export function getLocationCommonWellItemViewStateFromLocationType(
    locationType: WeatherLocationType
): LocationCommonWellItemViewState {
    return {
        persona: {
            personaId: locationType.LocationId,
            displayName: locationType.Name,
            postalAddress: {
                Latitude: parseFloat(locationType.Latitude),
                Longitude: parseFloat(locationType.Longitude),
            } as PersonaPostalAddress,
        },
        text: locationType.Name,
        isValid: true,
        isSelected: false,
        isContextMenuOpen: false,
    } as LocationCommonWellItemViewState;
}
